module.exports = __webpack_public_path__ + "img/card-content-5.21949c6d.png";